import { useState, useMemo } from "react";
import { useSelector } from "redux/hooks";
import { DragEvent } from "react";
import { useFileUploader } from "utils/fileUploadS3";

import { AllowedFileTypes, videoURL, audioURL } from "utils/constants";
// import useRouter from "hooks/useRouter";
import {
  classifyFiles,
  hasInvalidVideoDuration,
  // shouldPreventMultipleVideoUpload,
  // validateFileTypes,
  isExceedingVideoDuration,
  isExceedingAudioDuration,
  validateMaxFileCount,
  hasInvalidAudioDuration,
  validateFile,
  validateImgFile,
} from "utils/fileService";
import {
  documentMaxCountReached,
  // audioMaxCountReached, videoMaxCountReached
} from "utils/chat";
import {
  // ChatType, EChatType,
  IFilePreview,
  //  setChatModel,
  setFilePreview,
} from "redux/actions";
import { convertFileNamesToLowercase } from "utils/functions";
import { useIntl } from "react-intl";
// import { store } from "redux/store";

export interface StoredFile {
  file: File;
  preview: string;
  id: string;
  extension?: string;
  error?: string;
  reason?: "type" | "size" | "load" | "length" | "duration" | "error";
}

export interface FileUploadHookResult {
  errorModal: {
    message: string;
    show: boolean;
    option?: Record<string, number>;
  };
  setErrorModal: React.Dispatch<
    React.SetStateAction<{
      message: string;
      show: boolean;
      option?: Record<string, number>;
    }>
  >;
  messageId: string;
  setMessageId: React.Dispatch<React.SetStateAction<string>>;
  handleDrop: (
    event: DragEvent<HTMLElement> | undefined,
    isUpload?: boolean
  ) => Promise<void>;
  resetFileUpload: () => void;
  fileLimit: number;
  handleFileSelect: (
    event: React.ChangeEvent<HTMLInputElement>,
    isUpload?: boolean
  ) => void;
  handleFileUpload: (
    files: FileList | null,
    isUpload?: boolean
  ) => Promise<void>;
}

// 视频和音频文件时长限制（单位：秒）
const MAX_VIDEO_DURATION = 30 * 60; // 30 分钟
const MAX_AUDIO_DURATION = 60 * 60; // 60 分钟

export const useFileUpload = (chatContent?: boolean): FileUploadHookResult => {
  // const { pathname } = useRouter();
  const { uploadToS3 } = useFileUploader();
  const { formatMessage } = useIntl();

  const { chatContentUploadingFiles, FilePreview, isModalOpen } = useSelector(
    (state) => state.workSpaceReducer
  );
  const { userDetail, gptModel } = useSelector((state) => state.authReducer);
  const { FileContent } = useSelector((state) => state.chatReducer);
  const currentPlan = useSelector(
    (state) => state.planSubscriptionReducer.activePlan
  );

  // const { chatModels } = useSelector((state) => state.chatModelsReducer);
  // const { newMessages,
  //   // messages
  // } = useSelector((state) => state.chatReducer);

  // const [changeModel, setChangeModel] = useState<boolean>(false);
  const [messageId, setMessageId] = useState<string>("");
  const [errorModal, setErrorModal] = useState<{
    message: string;
    show: boolean;
    option?: Record<string, number>;
  }>({
    message: "",
    show: false,
  });

  // const [fileUploadAllow, setAllowFile] = useState<boolean>(false);

  // const history = pathname.includes("/workspaces/thread");

  // const fileLimit =
  //   userDetail?.user.activeSubscription?.name === "Free"
  //     ? 5
  //     : (userDetail?.user.activeSubscription?.name === "Standard" ||
  //       userDetail?.user.activeSubscription?.name === "Professional" )
  //       ? 50
  //       : 100;

  // const claudAllowedFileSize = gptModel?.name.includes("GPT-4") ? 15 : 5;

  const fileSizeLimit = useMemo(() => {
    const subscriptionName =
      userDetail?.user?.activeSubscription?.name?.toLowerCase();

    switch (subscriptionName) {
      case "business":
      case "team":
        return 100;
      case "professional":
      case "standard":
        return 50;
      default:
        return 5;
    }
  }, [userDetail]);

  const fileCountLimit = useMemo(() => {
    const subscriptionName =
      userDetail?.user?.activeSubscription?.name?.toLowerCase();

    switch (subscriptionName) {
      case "business":
        return 20;
      case "team":
        return 10;
      case "standard":
      case "professional":
        return 5;
      default:
        return 1;
    }
  }, [userDetail]);

  const claudAllowedFileSize = useMemo(() => {
    return gptModel?.name.includes("GPT-4") ? 15 : 5;
  }, [gptModel]);

  const setValidationError = (
    messageKey: string,
    option?: Record<string, number>
  ) => {
    setErrorModal({ message: messageKey, show: true, option });
  };

  const resetFileUpload = () => {
    // Implement reset logic here if needed
  };

  // const validateAndSetModel = (chatType: EChatType, modelKey: string) => {
  //   const supportedModels = chatModels
  //     .filter((model) => model.type.includes(chatType))
  //     .map((model) => model.name);

  //   if (!supportedModels.includes(gptModel?.name ?? "")) {
  //     const storedModel = localStorage.getItem(modelKey);
  //     const selectedModel = storedModel
  //       ? JSON.parse(storedModel)
  //       : chatType === "image_chat" ? chatModels[1] : chatModels[0];
  //     localStorage.setItem(modelKey, JSON.stringify(selectedModel));
  //     localStorage.setItem("GptModel", JSON.stringify(selectedModel));
  //     setChatModel(selectedModel);
  //   }
  // };

  //  console.log("chatContentUploadingFiles",chatContentUploadingFiles)
  //  console.log("newChatContentUploadingFiles",wsUploadedFiles)

  const handleFileUpload = async (
    files: FileList | null,
    isUpload?: boolean
  ) => {
    if (!files?.length) return;

    const {
      valid,
      errorFile,
      files: storedFiles,
    } = await processSelectedFiles(files); // storeFiles
    if (!valid && errorFile?.reason) {
      switch (errorFile.reason) {
        case "length":
          if (fileCountLimit === 20) {
            setValidationError("documentChat.file.fileCountLimitMax", {
              count: fileCountLimit,
            });
          } else {
            setValidationError("documentChat.file.fileCountLimit", {
              count: fileCountLimit,
            });
          }

          break;
        case "type":
          setValidationError("documentChat.url.fileTypeFormat");
          break;
        case "size":
          if (fileSizeLimit === 100) {
            setValidationError("documentChat.file.fileSizeLimitMax", {
              size: fileSizeLimit,
            });
          } else {
            setValidationError("documentChat.file.fileSizeLimit", {
              size: fileSizeLimit,
            });
          }

          break;
        case "duration":
          if (errorFile.extension && videoURL.includes(errorFile.extension)) {
            setValidationError("documentChat.file.videoDurationLimit", {
              duration: MAX_VIDEO_DURATION / 60,
            });
          } else if (
            errorFile.extension &&
            audioURL.includes(errorFile.extension)
          ) {
            setValidationError("documentChat.file.audioDurationLimit", {
              duration: MAX_AUDIO_DURATION / 60,
            });
          }
          break;
        case "error":
          setValidationError("documentChat.file.error");
          break;
        default:
          // Handle unexpected reasons (optional logging)
          console.warn("Unknown error reason:", errorFile.reason);
      }
      return;
    }

    if (valid && storedFiles && storedFiles.length > 0) {
      const uploadFiles = storedFiles.map((storedFiles) => storedFiles.file);

      const newFilesArray = Array.from(uploadFiles);

      const { imageFiles, otherFiles } = classifyFiles(newFilesArray); // videoFiles, audioFiles,

      if (otherFiles) {
        const otherFile = convertFileNamesToLowercase(otherFiles);
        uploadFilesToS3(otherFile, isUpload);
      }

      if (imageFiles) {
        const imgFile = convertFileNamesToLowercase(imageFiles);
        uploadFilesToS3(imgFile, isUpload);
      }
    }

    const newFilesArray = Array.from(files);

    return;

    const { imageFiles, videoFiles, audioFiles, otherFiles } =
      classifyFiles(newFilesArray);
    const UploadFiles = isUpload
      ? chatContentUploadingFiles
      : chatContent
        ? FilePreview
        : chatContentUploadingFiles;
    const newImageFilesCount = newFilesArray.filter((file) =>
      file.type.startsWith("image/")
    ).length;
    const newOtherFilesCount = newFilesArray.length - newImageFilesCount;

    const uploadingOtherFiles = chatContentUploadingFiles.filter(
      (file) => file.fileType !== "image"
    ).length;
    const previewOtherFiles = FilePreview.filter(
      (file) => !file.file.type.startsWith("image/")
    ).length;
    const Total_Otherfiles =
      uploadingOtherFiles + newOtherFilesCount + previewOtherFiles;

    const uploadingImageFiles = chatContentUploadingFiles.filter(
      (file) => file.fileType === "image"
    ).length;
    const previewImageFiles = FilePreview.filter((file) =>
      file.file.type.startsWith("image/")
    ).length;
    const Total_Imagefiles =
      uploadingImageFiles + newImageFilesCount + previewImageFiles;

    if (chatContentUploadingFiles.length > 0 && chatContent) {
      if (Total_Imagefiles > 20) {
        setValidationError("ImageChat.file.fileLimit");
        return;
      } else if (Total_Otherfiles > 5) {
        setValidationError("documentChat.file.fileLimit");
        return;
      }
    }

    const newCount = otherFiles.length;

    const existingCount = (UploadFiles ?? []).filter(
      (file) => !file.file.type.startsWith("image")
    ).length;

    const totalCount = existingCount + newCount;

    if (totalCount > 5) {
      setValidationError("documentChat.file.fileLimit");
      return;
    }

    if (await hasInvalidVideoDuration(videoFiles)) {
      setValidationError("validate.video.duration");
      return;
    }
    if (await hasInvalidAudioDuration(audioFiles)) {
      setValidationError("validate.audio.duration");
      return;
    }
    let filteredFiles;
    if (isUpload || !chatContent) {
      filteredFiles = (chatContentUploadingFiles ?? []).filter(
        (file) => !file.file.type.startsWith("image")
      );
    } else {
      filteredFiles = (FilePreview ?? []).filter(
        (file) => !file.file.type.startsWith("image")
      );
    }

    if (!validateMaxFileCount(otherFiles, 5, filteredFiles)) {
      setValidationError("documentChat.file.fileLimit");
      return;
    }
    await processFiles({
      imageFiles,
      otherFiles,
      isUpload,
    });
  };

  const processFiles = async ({
    imageFiles,
    otherFiles,
    isUpload,
  }: {
    imageFiles: File[];
    otherFiles: File[];
    isUpload: boolean | undefined;
  }) => {
    if (imageFiles.length > 0) {
      handleImageFiles(imageFiles, isUpload);
    }
    if (otherFiles.length > 0) {
      handleDocumentFiles(otherFiles, isUpload);
    }
  };

  const handleImageFiles = async (
    files: File[],
    isUpload: boolean | undefined
  ) => {
    // Handle file selection and validation
    let shouldStopExecution = false;

    // Fetch valid files first
    const validFiles = await handleFileLimit(files, 20);
    if (validFiles === null) {
      shouldStopExecution = true;
      resetFileUpload();
      return;
    }

    if (shouldStopExecution) return;

    const imgFile = convertFileNamesToLowercase(files);
    uploadFilesToS3(imgFile, isUpload);
  };

  const handleDocumentFiles = async (
    files: File[],
    isUpload: boolean | undefined
  ) => {
    if (documentMaxCountReached(currentPlan, userDetail)) {
      setMessageId("documentChat.plan.max_count");
      resetFileUpload();
      return;
    }
    const isFree = checkForFreeLimit(
      files,
      "documentChat.plan.max_count",
      isUpload
    );
    if (isFree === false) return;

    uploadFilesToS3(files, isUpload);
  };

  const checkForFreeLimit = (
    files: File[],
    messageId: string,
    isUpload?: boolean | undefined
  ) => {
    const isFreeUser = userDetail?.user.activeSubscription?.name === "Free";
    const UploadFiles = isUpload
      ? chatContentUploadingFiles
      : chatContent
        ? FilePreview
        : chatContentUploadingFiles;
    const totalFilesCount =
      (UploadFiles ? UploadFiles.length : 0) + files.length;
    if (isFreeUser && (files.length > 1 || totalFilesCount > 1)) {
      resetFileUpload();
      setMessageId(messageId);
      return false;
    }
    return true;
  };

  const handleFileLimit = (
    files: File[],
    limit: number,
    isUpload?: boolean | undefined
  ): File[] | null => {
    const UploadFiles = isUpload
      ? chatContentUploadingFiles
      : chatContent
        ? FilePreview
        : chatContentUploadingFiles;
    if (files[0]?.type.startsWith("image/")) {
      if (files.length > 20) {
        setErrorModal({ message: "ImageChat.file.fileLimit", show: true });
        return null;
      }

      const existingImageCount = (UploadFiles ?? []).filter((file) =>
        file.file.type.startsWith("image")
      ).length;
      if (existingImageCount + files.length > 20) {
        setErrorModal({ message: "ImageChat.file.fileLimit", show: true });
        return null;
      }

      return files;
    }
    if (files.length > limit && UploadFiles && UploadFiles.length === 0) {
      setErrorModal({ message: "ImageChat.file.fileLimit", show: true });
      return null;
    } else return files;
  };

  const uploadFilesToS3 = async (
    files: File[],
    isUpload?: boolean | undefined
  ) => {
    if (!files[0]?.type?.startsWith("image/")) {
      if (documentMaxCountReached(currentPlan, userDetail)) {
        setMessageId("documentChat.plan.max_count");
        return;
      }
    }

    // Convert files to IChatContentUploadFile format
    // const fileList: IFilePreview[] = files.map((file) => ({
    //   file,
    //   errorMessage: "",
    // }));
    // fileList.forEach((file) => setFilePreview(file));

    const fileArray = Array.from(files);
    const fileType = files[0]?.type.startsWith("image/")
      ? "image"
      : files[0]?.type.startsWith("video/")
        ? "video"
        : "document";
    const validFiles =
      fileType === "image"
        ? validateImgFile(
            fileArray,
            setErrorModal,
            claudAllowedFileSize,
            formatMessage
          )
        : validateFile(
            fileArray,
            setErrorModal,
            userDetail,
            formatMessage,
            setMessageId
          );
    // Convert files to IChatContentUploadFile format
    if (validFiles) {
      const fileList: IFilePreview[] = files.map((file) => ({
        file,
        errorMessage: "",
      }));
      fileList.forEach((file) => setFilePreview(file));
    }
    if (isModalOpen) {
      if (isUpload) {
        if (validFiles) {
          await uploadToS3({
            fileArray,
            fileType,
          });
        }
      }
    } else if (chatContent !== true) {
      if (validFiles) {
        await uploadToS3({
          fileArray,
          fileType,
        });
      }
    }
  };

  const handleFileSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
    isUpload?: boolean
  ) => {
    if (!event.target.files?.length) return;
    handleFileUpload(event.target.files, isUpload);
    event.target.value = "";
  };

  const handleDrop = async (
    event: DragEvent<HTMLElement> | undefined,
    isUpload?: boolean
  ) => {
    event?.preventDefault();
    const files = event?.dataTransfer?.files ?? null;
    handleFileUpload(files, isUpload);
  };

  /**
   * 处理文件选择，过滤文件并返回 { valid, files, errorFile } 格式的数据
   * @param files 用户选择的文件列表
   * @returns { valid: boolean, storeFiles: StoredFile[], errorFile?: StoredFile } - valid 表示是否无错误，files 包含所有文件，errorFile 为第一个错误文件（如果有）
   */
  async function processSelectedFiles(
    files: FileList | null
  ): Promise<{ valid: boolean; files: StoredFile[]; errorFile?: StoredFile }> {
    // 如果没有文件或文件列表为空，返回 valid: false, 空 files 和 undefined errorFile
    if (!files?.length)
      return { valid: false, files: [], errorFile: undefined };

    const storedFiles: StoredFile[] = [];
    const filesArray = Array.from(files);
    let firstErrorFile: StoredFile | undefined = undefined;

    const maxFileCount =
      fileCountLimit -
      (chatContentUploadingFiles?.length ?? 0) -
      (FileContent?.length ?? 0);

    // 1. 检查文件数量是否超过限制（放在最前面，忽视 error 值）
    if (filesArray.length > maxFileCount) {
      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        const storedFile: StoredFile = {
          file,
          preview: "",
          id: crypto.randomUUID(), // 生成唯一 ID
          extension: file.name.split(".").pop()?.toLowerCase(),
        };

        // 标记超出限制的文件为数量超限
        if (i >= maxFileCount) {
          storedFile.error = "Maximum file count exceeded";
          storedFile.reason = "length";
          if (!firstErrorFile) firstErrorFile = storedFile; // 记录第一个错误文件
        }
        storedFiles.push(storedFile);
      }
      return { valid: false, files: storedFiles, errorFile: firstErrorFile };
    }

    // 2. 遍历文件并进行类型、大小和加载检查
    for (const file of filesArray) {
      const extension = file.name.split(".").pop()?.toLowerCase();
      const storedFile: StoredFile = {
        file,
        preview: "",
        id: crypto.randomUUID(), // 生成唯一 ID
        extension,
      };

      // 3. 检查文件类型（基于扩展名）
      if (!extension || !AllowedFileTypes.includes(extension)) {
        storedFile.error = "Unsupported file type";
        storedFile.reason = "type";
        if (!firstErrorFile) firstErrorFile = storedFile;
        storedFiles.push(storedFile);
        return { valid: false, files: storedFiles, errorFile: firstErrorFile };
      }

      // 4. 检查文件大小
      const fileSize = file.size;
      if (fileSize > fileSizeLimit * 1024 * 1024) {
        storedFile.error = `File size exceeds ${fileSizeLimit}MB`;
        storedFile.reason = "size";
        if (!firstErrorFile) firstErrorFile = storedFile;
        storedFiles.push(storedFile);
        return { valid: false, files: storedFiles, errorFile: firstErrorFile };
      }

      // 5. 尝试生成预览（仅对图片和视频）
      if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
        try {
          storedFile.preview = await generateFilePreview(file);
        } catch (error) {
          storedFile.error = "Failed to load file";
          storedFile.reason = "load";
          if (!firstErrorFile) firstErrorFile = storedFile;
          storedFiles.push(storedFile);
          return {
            valid: false,
            files: storedFiles,
            errorFile: firstErrorFile,
          };
        }
      }

      // 6. 检查视频或音频时长
      if (file.type.startsWith("video/") || file.type.startsWith("audio/")) {
        try {
          if (file.type.startsWith("video/")) {
            if (await isExceedingVideoDuration(file)) {
              storedFile.error = `Video duration exceeds ${MAX_VIDEO_DURATION / 60} minutes`;
              storedFile.reason = "duration";
              if (!firstErrorFile) firstErrorFile = storedFile;
              storedFiles.push(storedFile);
              return {
                valid: false,
                files: storedFiles,
                errorFile: firstErrorFile,
              };
            }
          }

          if (file.type.startsWith("audio/")) {
            if (await isExceedingAudioDuration(file)) {
              storedFile.error = `Audio duration exceeds ${MAX_AUDIO_DURATION / 60} minutes`;
              storedFile.reason = "duration";
              if (!firstErrorFile) firstErrorFile = storedFile;
              storedFiles.push(storedFile);
              return {
                valid: false,
                files: storedFiles,
                errorFile: firstErrorFile,
              };
            }
          }
        } catch (error) {
          console.log("error", error);
          storedFile.error = "Failed to load file duration";
          storedFile.reason = "error";
          if (!firstErrorFile) firstErrorFile = storedFile;
          storedFiles.push(storedFile);
          return {
            valid: false,
            files: storedFiles,
            errorFile: firstErrorFile,
          };
        }
      }

      // 如果没有错误，添加到 storedFiles
      storedFiles.push(storedFile);
    }

    // 如果没有错误，返回 valid: true 和所有文件
    return { valid: true, files: storedFiles, errorFile: undefined };
  }

  /**
   * 生成文件预览（图片或视频）
   * @param file 文件对象
   * @returns 预览 URL
   */
  async function generateFilePreview(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error("Failed to generate preview"));
      reader.readAsDataURL(file);
    });
  }

  return {
    errorModal,
    setErrorModal,
    messageId,
    setMessageId,
    handleDrop,
    resetFileUpload,
    fileLimit: fileSizeLimit,
    handleFileSelect,
    handleFileUpload,
  };
};
